import React, { type RefObject } from "react";
import { AnimatePresence } from "framer-motion";
import styled from "styled-components";
import { theme } from "../../theme";
import { useSlidePanel } from "../../hooks/useSlidePanel";
import { PanelAnchor } from "../atoms/SlideActionPanel";

const Container = styled.div<{ bgColor?: string }>`
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid ${theme.colors.border};
  background-color: ${({ bgColor }) => bgColor ?? theme.colors.grey02};
  display: flex;
  align-items: center;
  gap: 24px;
  position: relative;
  z-index: 2;
`;

interface Props {
  actions: (
    openPanel: (panel: string) => void,
    closePanel: () => void,
  ) => React.ReactNode;
  panels: (
    isActivePanel: (panel: string) => boolean,
    panelRef: RefObject<HTMLDivElement | null>,
    panelDirection: "up" | "down",
    closePanel: () => void,
  ) => React.ReactNode;
  minWidth?: number | string;
  bgColor?: string;
}

const SlideActionToolbar: React.FC<Props> = ({
  actions,
  panels,
  minWidth,
  bgColor,
}) => {
  const {
    anchorRef,
    panelRef,
    activePanel,
    setActivePanel,
    panelDirection,
    openPanel,
  } = useSlidePanel<string>();
  const closePanel = () => setActivePanel(null);

  return (
    <PanelAnchor
      ref={anchorRef}
      style={{
        zIndex: activePanel ? 10 : undefined,
      }}
    >
      <Container
        style={{
          minWidth: minWidth !== undefined ? minWidth : undefined,
          backgroundColor: bgColor ?? theme.colors.grey02,
        }}
      >
        {actions(openPanel, closePanel)}
      </Container>
      <AnimatePresence>
        {panels((p) => activePanel === p, panelRef, panelDirection, closePanel)}
      </AnimatePresence>
    </PanelAnchor>
  );
};

export default SlideActionToolbar;
